import { isUndefinedOrEmpty } from '@afterpay/utils'

export interface TargetingKeyParams {
  key: string
  cohort?: string
}

export const buildTargetingKey = ({ key, cohort }: TargetingKeyParams): string => {
  const cohortStr = !isUndefinedOrEmpty(cohort) ? `-${cohort}` : ''

  return `${key}${cohortStr}`
}
